import React, { useEffect } from 'react';

const Count = () => {
  useEffect(() => {
    // Simulate PureCounter behavior here
    const counters = document.querySelectorAll('.purecounter');
    counters.forEach((counter) => {
      const start = +counter.getAttribute('data-purecounter-start');
      const end = +counter.getAttribute('data-purecounter-end');
      const duration = +counter.getAttribute('data-purecounter-duration');

      let current = start;
      const step = (end - start) / (duration * 60); // 60 frames per second

      const updateCounter = () => {
        if (current < end) {
          current += step;
          counter.innerText = Math.ceil(current);
          requestAnimationFrame(updateCounter);
        }
      };

      updateCounter();
    });
  }, []);

  return (
    <section id="counts" className="counts section-bg">
      <div className="container">
      <h2 id='roboto' className=' margint'>OUR TEAMS</h2>
        <div className="row counters">
          <div className="col-lg-3 col-6 text-center">
            <span
              data-purecounter-start="0"
              data-purecounter-end="1014"
              data-purecounter-duration="1"
              className="purecounter"
            ></span>
            <p>Active Users</p>
          </div>

          <div className="col-lg-3 col-6 text-center">
            <span
              data-purecounter-start="0"
              data-purecounter-end="26"
              data-purecounter-duration="1"
              className="purecounter"
            ></span>
            <p>Admins</p>
          </div>

          <div className="col-lg-3 col-6 text-center">
            <span
              data-purecounter-start="0"
              data-purecounter-end="4"
              data-purecounter-duration="1"
              className="purecounter"
            ></span>
            <p>Groups</p>
          </div>

          <div className="col-lg-3 col-6 text-center">
            <span
              data-purecounter-start="0"
              data-purecounter-end="500000"
              data-purecounter-duration="1"
              className="purecounter"
            ></span>
            <p>Targeted users</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Count;
